import { render, staticRenderFns } from "./commissionConfig.vue?vue&type=template&id=73cbffbb&"
import script from "./commissionConfig.vue?vue&type=script&lang=js&"
export * from "./commissionConfig.vue?vue&type=script&lang=js&"
import style0 from "./commissionConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports